import { INSTALL_DES_COUNTRY } from '@/components/calculators/power-kits/components/Step456';
import InfoCollection from '@/components/PowerKitPreSale/components/PreOrder/infocollection';
import { toMM100GetQuote } from '@/components/PowerKitPreSale/components/PreOrder/InfoQuote/utils';
import SuccessDialog from '@/components/PowerKitPreSale/components/PreOrder/successDialog';
import Image from '@/components/UI/Image';
import EFArrowLeft from '@/components/UI/svg/Icons/EFArrowLeft';
import PayPalIcon from '@/components/UI/svg/Icons/PayPalIcon';
import FixedCalculatorFooter from '@/componentsH5/calculators/components/FixedCalculatorFooter';
import { FormatMoney } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { memo } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { InstallQuestionModal } from '../Step456';
import css from './index.module.scss';
function Child({ data, callBack, staticData }: any) {
    const { useLang, useRouter, useState, useEffect, gtm, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('shared');
    const [swiperImgs, setSwiperImgs] = useState([]);
    const [active, setActive] = useState(0);
    const [swiper, setSwiper] = useState({ activeIndex: 0 });
    const { bundleImgs, comboPrice, taxPriceTag, wire, isPriveReverseFlag, installTerms } = staticData;
    const [installQuestionVisible, setInstallQuestionVisible] = useState(false);
    const [showDetailsModal_CN, setShowDetailsModal_CN] = useState(false);

    const installSpecialSites = ['us', 'ca'];
    const activityIdMap: any = {
        us: '3',
        eu: '5',
        ca: '4',
        au: '11',
        uk: '6',
        kr: '10',
        de: '7',
        fr: '8',
        jp: '9',
        cn: '12',
    };
    const [showInfoCollection, setShowInfoCollection] = useState(false);
    const [showInfoSuccess, setShowInfoSuccess] = useState(false);
    const collectInfoCb = ({ status }: any) => {
        if (status === 'success') {
            setShowInfoCollection(false);
            setShowInfoSuccess(true);
        }
        switch (status) {
            case 'success':
                setShowInfoCollection(false);
                setShowInfoSuccess(true);
                break;
            case 'close':
                setShowInfoCollection(false);
                break;
        }
    };

    useEffect(() => {
        const arr: any = [];
        if (data?.selectedPower) {
            arr.push({
                img: `/img/calculators/mm100H5/${bundleImgs[data?.bundle]}`,
                name: data?.selectedPower?.name,
            });
        }
        arr.push({ img: '/img/calculators/mm100H5/wire.jpg', name: wire?.name });
        if (data?.selectedCombo && data?.selectedCombo?.productId !== 0) {
            data?.selectedCombo?.subs?.map((sub: any) =>
                arr.push({
                    img: sub?.imgH5,
                    name: sub?.name,
                }),
            );
        }
        data?.solarOptions?.map((solar: any) => {
            if (solar?.number > 0) {
                arr.push({ img: solar?.imgH5, name: solar?.name });
            }
        });
        setSwiperImgs(arr);
    }, [data]);

    const onTryAgain = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'calculator5',
            step: 'result',
            product_name: 'MM100',
            price: (data?.selectedPower?.unit || '') + data.totalDiscount,
            button_name: 'Try Again',
        });
        callBack({}, true);
    };

    const onCheckout = () => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'calculator5',
                step: 'result',
                product_name: 'MM100',
                price: (data?.selectedPower?.unit || '') + data.totalDiscount,
                button_name: 'Checkout',
            });
            window?.fbq && window?.fbq('track', 'SubmitApplication');
        } catch (e) {
            console.log(e);
        } finally {
            if (locale !== 'cn') {
                // onTryAgain()
                let fragLink = '';
                data?.solarOptions
                    ?.filter((solar: any) => solar?.number > 0)
                    ?.map((option: any) => {
                        fragLink += `,${option?.variantId}:${option?.number}`;
                    });
                if (data?.selectedInstall?.variantId) {
                    fragLink += `,${data?.selectedInstall?.variantId}:1`;
                }
                fragLink += '?channel=buy_button';
                // fragLink += process.env.NODE_ENV === 'production' ? '' : '?channel=buy_button'
                return window.open(`https://${locale}.ecoflow.com/cart/${data?.bundle}:1${fragLink}`, '_blank');
            } else {
                return setShowDetailsModal_CN(true);
            }
        }
    };

    const onSwiperSlideTo = (index: number) => {
        if (swiper && index !== active) {
            swiper?.slideTo(index);
        }
    };

    let originX = 0,
        startX = 0;
    const touchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };

    const touchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    const openQoute = () => {
        if (['us', 'ca'].includes(locale)) toMM100GetQuote(locale);
        else setShowInfoCollection(true);
    };

    const renderItem = (item: any, k: string, type = 'power') => {
        return (
            <div className="info-item" key={k}>
                <div className="info-item-img">
                    <Image src={item?.imgH5} layout="fill" className="fullIImgs" alt={item?.title || item?.name} aria-label={item?.title || item?.name} />
                </div>
                <div className="info-item-text">
                    <p className="text-title">{item?.productName || item?.name}</p>
                    {
                        <div className="priceBox">
                            {locale !== 'cn' && (
                                <span className="discountPrice">
                                    {!isPriveReverseFlag && `${item?.unit} `}
                                    {FormatMoney(item?.discountPrice, isPriveReverseFlag ? ' ' : ',')}
                                    {isPriveReverseFlag && ` ${item?.unit}`}
                                    {taxPriceTag[locale] || ''}
                                </span>
                            )}
                            {locale === 'cn' && <span className="discountPrice">{t('calculators.mm100.step4.inquiry')}</span>}
                            {item?.discountPrice !== item?.originalPrice && locale !== 'cn' && (
                                <span className="originalPrice">
                                    {!isPriveReverseFlag && `${item?.unit} `}
                                    {FormatMoney(item?.originalPrice, isPriveReverseFlag ? ' ' : ',')}
                                    {isPriveReverseFlag && ` ${item?.unit}`}
                                    {taxPriceTag[locale] || ''}
                                </span>
                            )}
                            <span className="count">x{item?.number || 1}</span>
                        </div>
                    }
                    {item?.discountPrice !== item?.originalPrice && locale !== 'cn' && (
                        <p className="savePrice">
                            {`${t('calculators.mm100.step7.save')} `}
                            {!isPriveReverseFlag && `${item?.unit} `}
                            {FormatMoney(item?.discountPrice, isPriveReverseFlag ? ' ' : ',')}
                            {isPriveReverseFlag && ` ${item?.unit}`}
                            {taxPriceTag[locale] || ''}
                        </p>
                    )}
                    {item?.freeShip === 1 && <div className="free-ship">{t('calculators.mm100.step4.free_shiping')}</div>}
                </div>
            </div>
        );
    };

    const onInstallQuestion = (e: any) => {
        if (e && e.stopPropagation) {
            e.stopPropagation();
        } else {
            window.event.cancelBubble = true;
        }
        setInstallQuestionVisible(true);
    };

    const closeInstall = (e: any) => {
        if (e && e.stopPropagation) {
            e.stopPropagation();
        } else {
            window.event.cancelBubble = true;
        }
        setInstallQuestionVisible(false);
    };

    return (
        <div className={`step7H5 ${css.step7H5}`}>
            <p className="step7-title">{t('calculators.mm100.step7.title')}</p>
            <div className="mainBox">
                <Swiper
                    className={`m100-preview-swiperH5 ${swiperImgs?.length === 1 ? 'single' : ''}`}
                    initialSlide={0}
                    preloadImages={false}
                    lazy={true}
                    centeredSlides={true}
                    grabCursor={true}
                    navigation={true}
                    onSwiper={(swiper: any) => setSwiper(swiper)}
                    onSlideChange={(swiper: any) => setActive(swiper?.activeIndex)}
                >
                    {swiperImgs?.map((item: any, k: number) => (
                        <SwiperSlide key={k}>
                            <div className="swiperImg">
                                <Image
                                    className="step7H5-swiper-item-img fullImgs"
                                    src={item?.img || '/img/search/error.png'}
                                    layout="fill"
                                    alt={item?.name}
                                    aria-label={item?.name}
                                />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
                {swiperImgs?.length > 1 && (
                    <div className="paginationImgs">
                        <ul
                            className={`step7H5-smallImgs ${setSwiperImgs?.length > 5 ? 'leftAlign' : ''}`}
                            onTouchStart={touchStart}
                            onTouchMove={touchMove}
                            style={{ width: `${(66 * swiperImgs?.length - 16 + 71) / 100}rem` }}
                        >
                            {swiperImgs?.map((img: any, k: number) => (
                                <li className={`step7H5-smallImg ${k === active ? 'active' : ''}`} key={k} onClick={() => onSwiperSlideTo(k)}>
                                    <div className="smallImg-box">
                                        <Image src={img?.img} className="fullImgs" layout="fill" alt={img?.name} aria-label={img?.name} />
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
                <div className="rightBox">
                    <div className="powerBox contentBox">
                        <p className="info-title power-title">
                            {data?.selectedPower?.productName}
                            {locale !== 'jp' && <span className="tag">{t('calculators.mm100.step7.ultimate')}</span>}
                        </p>
                        {renderItem(data?.selectedPower, data?.selectedPower?.productId)}
                    </div>
                    {installSpecialSites.includes(locale) && (
                        <div className="installBox contentBox specialInstallBox">
                            <p className="info-title install-title">{t('calculators.mm100.step4.installation')}</p>
                            <li className="install-item">
                                <p className="install-text">{t(`calculators.mm100.step4.${data?.selectedInstall?.i18n}`)}</p>
                                <p className="install-des">
                                    {t.rich(`calculators.mm100.step4.${data?.selectedInstall?.i18n_des}`, {
                                        line: (text: any) => (
                                            <Link href="/support/videos" className="install-link" target="_blank">
                                                {text}
                                            </Link>
                                        ),
                                    })}
                                </p>
                                {data?.selectedInstall?.i18n_des && (
                                    <div className="install-desc">
                                        {locale !== 'us' && t(`calculators.mm100.step4.${data?.selectedInstall?.i18n_des}`)}
                                        {INSTALL_DES_COUNTRY.includes(locale) && (
                                            <span className="question" onClick={onInstallQuestion}>
                                                <Image
                                                    src={'/img/calculators/mm100/question-mark.svg'}
                                                    layout="fill"
                                                    className="fullImgs"
                                                    alt={t('calculators.mm100.step4.questionMark')}
                                                    aria-label={t('calculators.mm100.step4.questionMark')}
                                                />
                                                {installQuestionVisible && (
                                                    <div className="installModal">
                                                        <InstallQuestionModal terms={installTerms} callback={closeInstall} />
                                                    </div>
                                                )}
                                            </span>
                                        )}
                                    </div>
                                )}
                                <span className="number">x1</span>
                            </li>
                            <div className="quoteBox">
                                {t.rich('calculators.mm100.step4.quote', {
                                    line: (text: string) => (
                                        <span className="quoteLink" onClick={() => openQoute()}>
                                            {text}
                                        </span>
                                    ),
                                })}
                                {locale === 'us' && (
                                    <Link className="quoteLink" href="/where-to-buy">
                                        {t('calculators.mm100.step4.nearby')}
                                    </Link>
                                )}
                            </div>
                        </div>
                    )}
                    {data?.selectedCombo && data?.selectedCombo?.productId !== 0 && (
                        <div className="comboBox contentBox">
                            <p className="info-title combo-title">{t('calculators.mm100.step7.combo')}</p>
                            <div className="combo-item">
                                <p className="combo-item-title">{data?.selectedCombo?.name}</p>
                                <div className="priceBox">
                                    {locale !== 'cn' && (
                                        <span className="discountPrice">
                                            {!isPriveReverseFlag && `${data?.selectedCombo?.unit} `}
                                            {FormatMoney(
                                                comboPrice[data?.selectedPower?.productId].discount[data?.selectedCombo?.productId],
                                                isPriveReverseFlag ? ' ' : ',',
                                            )}
                                            {isPriveReverseFlag && ` ${data?.selectedCombo?.unit}`}
                                            {taxPriceTag[locale] || ''}
                                        </span>
                                    )}
                                    {locale === 'cn' && <span className="discountPrice">{t('calculators.mm100.step4.inquiry')}</span>}
                                    {comboPrice[data?.selectedPower?.productId].discount[data?.selectedCombo?.productId] !==
                                        comboPrice[data?.selectedPower?.productId].original[data?.selectedCombo?.productId] &&
                                        locale !== 'cn' && (
                                            <span className="originalPrice">
                                                {!isPriveReverseFlag && `${data?.selectedCombo?.unit} `}
                                                {FormatMoney(
                                                    comboPrice[data?.selectedPower?.productId].original[data?.selectedCombo?.productId],
                                                    isPriveReverseFlag ? ' ' : ',',
                                                )}
                                                {isPriveReverseFlag && ` ${data?.selectedCombo?.unit}`}
                                                {taxPriceTag[locale] || ''}
                                            </span>
                                        )}
                                    <span className="number">x1</span>
                                </div>
                                {comboPrice[data?.selectedPower?.productId].discount[data?.selectedCombo?.productId] !==
                                    comboPrice[data?.selectedPower?.productId].original[data?.selectedCombo?.productId] &&
                                    locale !== 'cn' && (
                                        <p className="savePrice">
                                            {`${t('calculators.mm100.step7.save')} `}
                                            {!isPriveReverseFlag && `${data?.selectedCombo?.unit} `}
                                            {FormatMoney(
                                                Math.round(
                                                    100 * comboPrice[data?.selectedPower?.productId].original[data?.selectedCombo?.productId] -
                                                        100 * comboPrice[data?.selectedPower?.productId].discount[data?.selectedCombo?.productId],
                                                ) / 100,
                                                isPriveReverseFlag ? ' ' : ',',
                                            )}
                                            {isPriveReverseFlag && ` ${data?.selectedCombo?.unit}`}
                                            {taxPriceTag[locale] || ''}
                                        </p>
                                    )}
                                {data?.selectedCombo?.subs?.length > 0 && (
                                    <ul className="combo-item-subs">
                                        {data?.selectedCombo?.subs?.map((sub: any, index: number) => (
                                            <li className="combo-item-sub" key={index}>
                                                <div className="combo-item-sub-img">
                                                    <Image src={sub?.imgH5} layout="fill" className="fullImgs" alt={sub?.title} aria-label={sub?.title} />
                                                </div>
                                                <div className="combo-item-sub-text">
                                                    <div className="title">{sub?.name}</div>
                                                    <div className="number">x1</div>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    )}
                    {data?.solarOptions?.some((solar: any) => solar?.number > 0) && (
                        <div className="solarBox contentBox">
                            <p className="info-title solar-title">{t('calculators.mm100.step7.solar')}</p>
                            {data?.solarOptions
                                ?.filter((solar: any) => solar?.number > 0)
                                ?.map((option: any) => renderItem(option, option?.productId, 'solar'))}
                        </div>
                    )}
                    {locale !== 'jp' && data?.selectedInstall?.variantId !== 0 && !installSpecialSites.includes(locale) && (
                        <div className="installBox contentBox">
                            <p className="info-title install-title">{t('calculators.mm100.step4.installation')}</p>
                            <li className="install-item">
                                <p className="install-text">{t(`calculators.mm100.step4.${data?.selectedInstall?.i18n}`)}</p>
                                {data?.selectedInstall?.i18n_des && (
                                    <div className="install-desc">
                                        {locale !== 'us' && t(`calculators.mm100.step4.${data?.selectedInstall?.i18n_des}`)}
                                        {INSTALL_DES_COUNTRY.includes(locale) && (
                                            <span className="question" onClick={onInstallQuestion}>
                                                <Image
                                                    src={'/img/calculators/mm100/question-mark.svg'}
                                                    layout="fill"
                                                    className="fullImgs"
                                                    alt={t('calculators.mm100.step4.questionMark')}
                                                    aria-label={t('calculators.mm100.step4.questionMark')}
                                                />
                                                {installQuestionVisible && (
                                                    <div className="installModal">
                                                        <InstallQuestionModal terms={installTerms} callback={closeInstall} />
                                                    </div>
                                                )}
                                            </span>
                                        )}
                                    </div>
                                )}
                                <span className="number">x1</span>
                            </li>
                        </div>
                    )}
                </div>
                <button className={`tryAgainBtn`} onClick={onTryAgain} aria-label={t('calculators.mm100.step7.try-again')}>
                    {t('calculators.mm100.step7.try-again')}
                </button>
            </div>
            <FixedCalculatorFooter>
                <>
                    <div
                        className={`step456-container ${css.shoppingcart} ${
                            Math.round(100 * data?.totalDiscount) === Math.round(100 * data?.totalOriginal) ? 'noDiscount' : ''
                        }`}
                    >
                        <div className="footer-price">
                            {locale !== 'cn' && (
                                <p className="total-discount">
                                    {!isPriveReverseFlag && `${data?.selectedPower?.unit} `}
                                    {FormatMoney(Math.round(100 * data?.totalDiscount) / 100, isPriveReverseFlag ? ' ' : ',')}
                                    {isPriveReverseFlag && ` ${data?.selectedPower?.unit}`}
                                    {taxPriceTag[locale] || ''}
                                </p>
                            )}
                            {locale === 'cn' && <p className="total-discount">{t('calculators.mm100.step4.inquiry')}</p>}
                            {locale !== 'cn' && (
                                <p className="total-original">
                                    {!isPriveReverseFlag && `${data?.selectedPower?.unit} `}
                                    {FormatMoney(Math.round(100 * data?.totalOriginal) / 100, isPriveReverseFlag ? ' ' : ',')}
                                    {isPriveReverseFlag && ` ${data?.selectedPower?.unit}`}
                                    {taxPriceTag[locale] || ''}
                                </p>
                            )}
                            {locale !== 'cn' && (
                                <span className="total-price-tag">
                                    {`${t('calculators.mm100.step4.save')} `}
                                    {!isPriveReverseFlag && `${data?.selectedPower?.unit} `}
                                    {FormatMoney(Math.round(100 * data?.totalOriginal - 100 * data?.totalDiscount) / 100, isPriveReverseFlag ? ' ' : ',')}
                                    {isPriveReverseFlag && ` ${data?.selectedPower?.unit}`}
                                    {taxPriceTag[locale] || ''}
                                </span>
                            )}

                            <button className="footer-checkout" onClick={onCheckout} aria-label={t('calculators.mm100.step7.checkout')}>
                                {t('calculators.mm100.step7.checkout')}
                            </button>
                        </div>

                        {locale === 'us' && (
                            <div className="paypal">
                                <span className="icon">
                                    <PayPalIcon />
                                </span>
                                <span className="text">Buy now,pay later</span>
                                <Link href="https://www.paypal.com/us/digital-wallet/ways-to-pay/buy-now-pay-later">
                                    Learn More
                                    <span className="arrow-icon">
                                        <EFArrowLeft />
                                    </span>
                                </Link>
                            </div>
                        )}
                    </div>
                    {showDetailsModal_CN && (
                        <div
                            className="after"
                            style={{ background: 'rgba(0,0,0,0.3)', position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                        ></div>
                    )}
                </>
            </FixedCalculatorFooter>
            {showDetailsModal_CN && (
                <div className="detailsModal_CN">
                    <div className="mask"></div>
                    <div className="modelBox">
                        <span className="close" onClick={() => setShowDetailsModal_CN(false)}>
                            &times;
                        </span>
                        <p className="title">正浩EcoFlow</p>
                        <p className="text">扫描二维码，添加我的企业微信</p>
                        <div className="qrCodeImg">
                            <Image src="/img/common/qrCode_EF.jpg" layout="fill" className="qrCode qrCode_cn" alt="二维码" aria-label="二维码" />
                        </div>
                        <div className="closeBtn" onClick={() => setShowDetailsModal_CN(false)}>
                            关闭
                        </div>
                    </div>
                </div>
            )}
            {installSpecialSites.includes(locale) && (
                <>
                    {showInfoCollection && <InfoCollection cbFunc={collectInfoCb} isCalculator={true} activityId={activityIdMap[locale] || activityIdMap.us} />}
                    {showInfoSuccess && <SuccessDialog isCalculator={true} closeSuccDialog={() => setShowInfoSuccess(false)} />}
                </>
            )}
        </div>
    );
}

const MemoDom = memo(Child);

export default function Step7({ data, callBack }: any) {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const staticData = require(`@/data/calculators/mm100/${locale || 'us'}`);
    return <MemoDom data={data} callBack={callBack} staticData={staticData()} />;
}
